/**
 * Generates a random string for the PKCE code verifier.
 * @param length The length of the string to generate (default: 64)
 * @returns A random string.
 */
export function generateCodeVerifier(length: number = 64): string {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  let text = '';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/**
 * Generates the PKCE code challenge based on the code verifier using SHA-256.
 * @param verifier The code verifier string.
 * @returns A Promise that resolves with the base64 URL-encoded code challenge.
 */
export async function generateCodeChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await window.crypto.subtle.digest('SHA-256', data);

  // Base64 URL encode the digest
  // btoa encodes to Base64, but we need Base64URL (RFC 4648 Section 5)
  // Replace '+' with '-', '/' with '_', and remove '=' padding
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}